import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query {
    regions {
      id
      name
    }
  }
`;

export const GET_ORDERS = gql`
  query Orders($regionId: ID!, $first: Int, $after: Int, $filter: String) {
    orders(regionId: $regionId, first: $first, after: $after, filter: $filter) {
      totalCount
      orders {
        createdAt
        id
        order
        payment
        reference
        regionId
        updatedAt
        websiteId
      }
    }
    clubs(regionId: $regionId) {
      id
      name
    }
  }
`;

export const UPDATE_ORDER_TESTING_FLAG = gql`
  mutation Order($reference: String!, $isTesting: Boolean!) {
    updateOrderTestingFlag(reference: $reference, isTesting: $isTesting) {
      createdAt
      id
      order
      payment
      reference
      regionId
      updatedAt
      websiteId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/graphql/index.ts